var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcInvite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2.525 2.857A4 4 0 0 0 1 6v12a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V6c0-1.275-.596-2.41-1.525-3.143A4 4 0 0 0 19 2H5c-.934 0-1.794.32-2.475.857M20.97 5.652A2 2 0 0 0 19 4H5a2 2 0 0 0-.916.222 2 2 0 0 0-1.054 1.43l.04.027 1.07.744h.002l7.756 5.393 7.978-5.421.001-.001 1.06-.721zM21 8.05V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8.065l7.757 5.393.002.001.457.318a1 1 0 0 0 .677.174 1 1 0 0 0 .668-.168l.46-.312.002-.001L21 8.049Z",
  clipRule: "evenodd"
})));
export default SvgIcInvite;